import { render, staticRenderFns } from "./DVideoSecureMultistep.vue?vue&type=template&id=06d6864f&scoped=true&"
import script from "./DVideoSecureMultistep.vue?vue&type=script&lang=js&"
export * from "./DVideoSecureMultistep.vue?vue&type=script&lang=js&"
import style0 from "./DVideoSecureMultistep.vue?vue&type=style&index=0&id=06d6864f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d6864f",
  null
  
)

export default component.exports